import { render, staticRenderFns } from "./ReservationDetailInfo.vue?vue&type=template&id=f34b3ce6&scoped=true&"
import script from "./ReservationDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./ReservationDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationDetailInfo.vue?vue&type=style&index=0&id=f34b3ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34b3ce6",
  null
  
)

export default component.exports